export const demoOwnerListings = [
  {
    id: 1,
    slug: "mangalore-harbour-fish-house",
    name: "Mangalore Harbour Fish House",
    tagline: "Straight from the sea to your plate",
    description:
      "A landmark seafood restaurant on the Mangalore harbour front serving fresh-catch fish curries, prawn gassi and Neer dosa since 1998.",
    address: "Old Port Road, Bunder, Mangalore, Dakshina Kannada - 575001",
    phone: "+91 824 245 3100",
    whatsapp: "+91 98440 53100",
    email: "info@mangaloreharbourfish.in",
    website: "https://mangaloreharbourfish.in",
    coverUrl:
      "https://readdy.ai/api/search-image?query=Coastal%20seafood%20restaurant%20exterior%20at%20dusk%20with%20warm%20string%20lights%20over%20a%20wooden%20facade%20beside%20a%20fishing%20harbour%2C%20rich%20warm%20editorial%20travel%20photography&width=1200&height=675&seq=owner-cover-01&orientation=landscape",
    logoUrl:
      "https://readdy.ai/api/search-image?query=Minimal%20circular%20restaurant%20logo%20mark%20of%20a%20stylised%20fish%20in%20warm%20ochre%20and%20deep%20green%20on%20a%20clean%20cream%20background%2C%20flat%20vector%20branding&width=256&height=256&seq=owner-logo-01&orientation=squarish",
    gallery: [],
    status: "active",
    rejectionReason: null,
    rating: 4.7,
    reviewCount: 612,
    isVerified: 1,
    isOpenNow: 1,
    createdAt: "2026-01-10T09:00:00Z",
    updatedAt: "2026-08-20T09:00:00Z",
    categoryId: 1,
    categoryName: "Restaurants & Cafes",
    categorySlug: "restaurants",
    districtId: 1,
    districtName: "South Canara (Dakshina Kannada)",
    districtSlug: "south-canara",
    townId: 1,
    townName: "Mangalore",
    planSlug: "business",
  },
  {
    id: 2,
    slug: "harbour-seafood-cloud-kitchen",
    name: "Harbour Seafood Cloud Kitchen",
    tagline: "Coastal favourites, delivered hot",
    description:
      "A takeaway and delivery-only kitchen bringing Mangalorean seafood classics to your doorstep across the city.",
    address: "Kadri Market Road, Kadri, Mangalore - 575002",
    phone: "+91 824 245 7788",
    whatsapp: null,
    email: "orders@harbourkitchen.in",
    website: "",
    status: "pending",
    rejectionReason: null,
    rating: 0,
    reviewCount: 0,
    isVerified: 0,
    isOpenNow: 1,
    createdAt: "2026-09-02T11:20:00Z",
    updatedAt: "2026-09-02T11:20:00Z",
    categoryId: 1,
    categoryName: "Restaurants & Cafes",
    categorySlug: "restaurants",
    districtId: 1,
    districtName: "South Canara (Dakshina Kannada)",
    districtSlug: "south-canara",
    townId: 1,
    townName: "Mangalore",
    planSlug: "free",
  },
  {
    id: 3,
    slug: "coastal-spice-trading",
    name: "Coastal Spice Trading",
    tagline: "Wholesale spices from the Malnad belt",
    description:
      "Bulk supplier of pepper, cardamom and kokum serving restaurants and retailers across the Canara districts.",
    address: "APMC Yard, Baikampady, Mangalore - 575011",
    phone: "+91 824 240 9911",
    whatsapp: "+91 90088 44221",
    email: "sales@coastalspice.in",
    website: "",
    status: "rejected",
    rejectionReason:
      "The provided address could not be verified. Please add a landmark or nearest bus stop and resubmit.",
    rating: 0,
    reviewCount: 0,
    isVerified: 0,
    isOpenNow: 0,
    createdAt: "2026-08-22T15:40:00Z",
    updatedAt: "2026-08-25T10:05:00Z",
    categoryId: 7,
    categoryName: "Supermarkets & Groceries",
    categorySlug: "supermarkets",
    districtId: 1,
    districtName: "South Canara (Dakshina Kannada)",
    districtSlug: "south-canara",
    townId: 1,
    townName: "Mangalore",
    planSlug: "free",
  },
  {
    id: 4,
    slug: "udupi-royal-grand-banquet",
    name: "Udupi Royal Grand Banquet",
    tagline: "Weddings, receptions and celebrations under one roof",
    description:
      "A spacious premium banquet hall in Udupi hosting weddings, receptions and corporate events for up to 800 guests, with in-house catering and decoration.",
    address: "Court Road, Udupi, Udupi District - 576101",
    phone: "+91 820 252 4400",
    whatsapp: "+91 98860 24400",
    email: "events@udupiroyalbanquet.in",
    website: "https://udupiroyalbanquet.in",
    videoUrl: "https://www.youtube.com/watch?v=ScMzIvxBSi4",
    coverUrl:
      "https://readdy.ai/api/search-image?query=Spacious%20banquet%20hall%20exterior%20in%20the%20evening%20with%20warm%20uplighting%20and%20palm-lined%20entrance%2C%20elegant%20event%20venue%20photography&width=1200&height=675&seq=owner-cover-04&orientation=landscape",
    logoUrl: null,
    gallery: [
      "https://readdy.ai/api/search-image?query=Elegant%20banquet%20hall%20interior%20with%20round%20tables%20and%20golden%20chandeliers%20set%20for%20a%20wedding%20reception%2C%20bright%20festive%20event%20photography&width=800&height=600&seq=owner-gal-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Wedding%20stage%20decorated%20with%20marigold%20flowers%20and%20draped%20fabric%20in%20a%20large%20banquet%20hall%2C%20warm%20celebratory%20event%20photography&width=800&height=600&seq=owner-gal-02&orientation=landscape",
    ],
    status: "active",
    rejectionReason: null,
    rating: 4.6,
    reviewCount: 143,
    isVerified: 1,
    isOpenNow: 1,
    createdAt: "2026-02-18T09:00:00Z",
    updatedAt: "2026-09-10T09:00:00Z",
    categoryId: 2,
    categoryName: "Banquet Halls & Event Venues",
    categorySlug: "hotels",
    districtId: 2,
    districtName: "Udupi",
    districtSlug: "udupi",
    townId: 2,
    townName: "Udupi",
    planSlug: "premium",
  },
  {
    id: 5,
    slug: "sunrise-ayurveda-wellness-retreat",
    name: "Sunrise Ayurveda Wellness Retreat",
    tagline: "Panchakarma and holistic healing by the Arabian Sea",
    description:
      "A premium wellness retreat offering authentic Ayurvedic treatments, yoga and detox programmes led by experienced physicians in a serene beachside setting near Byndoor.",
    address: "Ottinene Beach Road, Byndoor, Udupi District - 576214",
    phone: "+91 825 456 7788",
    whatsapp: "+91 98450 67788",
    email: "stay@sunriseayurveda.in",
    website: "https://sunriseayurveda.in",
    status: "active",
    rejectionReason: null,
    rating: 4.8,
    reviewCount: 96,
    isVerified: 1,
    isOpenNow: 1,
    createdAt: "2026-03-05T09:00:00Z",
    updatedAt: "2026-09-12T09:00:00Z",
    categoryId: 2,
    categoryName: "Resorts & Homestays",
    categorySlug: "hotels",
    districtId: 2,
    districtName: "Udupi",
    districtSlug: "udupi",
    townId: 2,
    townName: "Udupi",
    planSlug: "premium",
  },
];